import { Button, Card } from "antd-v4";
import React from "react";

interface Props {
  icon?: any;
  titleIcon?: any;
  title?: string;
  date?: string;
  number?: string;
  numberColor?: string;
  engagedNumber?: string;
  engagedNumberColor?: string;
  extraTextButton?: boolean;
  onExtraBtnClick?: () => void;
  extraButtonType?: "link" | "text" | "ghost" | "default" | "primary" | "dashed";
}

export default function FeatureCard(props: Props) {
  return (
    <Card className="hp-border-radius-lg hp-dashboard-feature-card hp-cursor-pointer">
      {props.icon && (
        <div
          className="hp-d-flex-full-center hp-dashboard-feature-card-icon hp-border-radius-lg hp-bg-black-20 hp-bg-dark-85"
          style={{ width: 48, height: 48 }}
        >
          {props.icon}
        </div>
      )}

      <div className="hp-d-flex hp-mt-12">
        {props.title && (
          <span className="h5 hp-mb-0 hp-d-block hp-text-color-black-bg hp-text-uppercase hp-text-color-dark-0 hp-font-weight-500 hp-mr-4">
            {props.title}
          </span>
        )}

        {props.titleIcon}
      </div>

      {props.date && (
        <span className="hp-caption hp-mt-4 hp-d-block hp-font-weight-400 hp-text-color-black-60">
          {props.date}
        </span>
      )}

      {props.number && props.engagedNumber ? (
        <div className="hp-d-flex hp-align-items-center hp-mt-12 hp-mb-8">
          <span className="hp-text-color-dark-0 h1" style={{ color: props.numberColor || "#000" }}>
            {props.number}
          </span>
          <span className="hp-caption hp-ml-8" style={{ color: props.engagedNumberColor || "#888", fontSize: "0.9em" }}>
            ({props.engagedNumber} déjà engagés)
          </span>
        </div>
      ) : (
        <span
          className="hp-text-color-dark-0 hp-d-block hp-mt-12 hp-mb-8 h1"
          style={{
            color: props.numberColor || "#000",
          }}
        >
          {props.number}
        </span>
      )}

      {
        props.extraTextButton && (
          <Button
            style={{ position: 'absolute', right: '1rem', bottom: '1rem' }}
            onClick={props.onExtraBtnClick}
            type={props.extraButtonType || "link"}
          >
            {props.extraTextButton}
          </Button>
        )
      }

    </Card>
  );
}
